import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-foreground-100/50 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mt-6">
          Strona nie została znaleziona
        </h2>
        <p className="mt-2 text-base text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-sm text-foreground-500">
          Przepraszamy, strona której szukasz nie istnieje.
        </p>
        <a
          href="/"
          className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium bg-primary-500 hover:bg-primary-600 text-background-50 rounded-md transition-colors whitespace-nowrap cursor-pointer no-underline"
        >
          <i className="ri-arrow-left-line"></i>
          Powrót do strony głównej
        </a>
      </div>
    </div>
  );
}